import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { IDocument } from '@type_definitions/datatypes';
import { FileUploadService } from './file-upload.service';
import { UrlService } from '../browser/url.service';
import { util } from '@app/shared/util';

@Component({
  selector: 'file-upload-manage',
  template: `
    <div *ngIf="fileUrl" class="margin-top-xs">
      <div class="btn-group" dropdown #dropdown="bs-dropdown">
        <button id="button-basic" dropdownToggle type="button" class="btn btn-sm dropdown-toggle dropdown-arrow-btn"></button>
        <ul *dropdownMenu class="dropdown-menu" role="menu">
          <li><a (click)="onDelete.emit()"><i class="fa fa-trash-o"></i> <span translate>GA.BUTTONS.DELETE</span></a></li>
        </ul>
        &nbsp;&nbsp;
      </div>
      <a [href]="fileUrl" target="_blank">{{fileName}}</a>
    </div>
    
    <button *ngIf="!fileUrl" class="btn btn-default" (click)="addFile($event)">
      {{ buttonLabel }}
    </button>
  `
})
export class FileUploadManageComponent implements OnInit, OnChanges {
  @Input() public uploadUrl:string;         // path where the file has to be uploaded
  @Input() public buttonLabel:string;       // label of the button
  @Input() public existingFile?:IDocument;  // an existing file that has previous uploaded (if available)

  @Output() public onUploadDone:EventEmitter<IDocument> = new EventEmitter();
  @Output() public onDelete:EventEmitter<IDocument> = new EventEmitter();

  public fileUrl:string;
  public fileName:string;

  constructor(
    private fileUploadService:FileUploadService,
    private urlService:UrlService
  ) {
    /***/
  }

  public ngOnInit():void {
    this.updateFile();
  }

  public addFile(e:Event):void {
    e.preventDefault();
    this.fileUploadService.showFileUploadDialog(this.uploadUrl, {
      document: this.existingFile,
      hideDocumentType: true,
      autoselect: !this.existingFile?.id
    })
      .then((result:IDocument) => {
        this.onUploadDone.emit(result);
      })
      .catch(util.noop);
  }

  public ngOnChanges(changes:SimpleChanges):void {
    if (changes?.existingFile) {
      this.existingFile = changes.existingFile.currentValue;
      this.updateFile();
    }
  }

  private updateFile(): void {
    this.fileUrl = this.existingFile?.id && this.urlService.getAttachmentUrl(this.existingFile.id);
    this.fileName = this.existingFile?.description;
  }
}